import type Dexie from 'dexie';
import { v001Harness } from './v001_harness';
import { v002AudioSpike } from './v002_audio_spike';

/**
 * NFR-7 — the forward-only migration chain, in order.
 *
 * Append new versions; never reorder, never edit a migration that has shipped. Dexie applies every
 * version between the one on the device and the newest declared here, so the list *is* the upgrade
 * path. A fixture database created at v001 is migrated through every entry on every test run
 * (design §13.3) — U-3 owns that fixture for the product schema; U-0 covers the harness schema in
 * `src/data/db.test.ts`.
 */
const MIGRATIONS: readonly ((db: Dexie) => void)[] = [v001Harness, v002AudioSpike];

export function applyMigrations(db: Dexie): void {
  for (const migrate of MIGRATIONS) migrate(db);
}

/** The version a fresh install lands on. Kept in step with `config.HARNESS_DB_VERSION`. */
export const LATEST_VERSION = MIGRATIONS.length;
